import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ValidStaffCode } from '../../../../shared/interface/valid-staff-code.interface';
import { AlertService } from '../../../../shared/services/alert.service';
import { CrudPromiseService } from '../../../../shared/services/crud-promise.service';

@Injectable({
    providedIn: 'root'
})
export class FacultyStaffTypeService extends CrudPromiseService<ValidStaffCode> {

    constructor(protected http: HttpClient, protected alert: AlertService) {
        super(http, 'validStaffCode', alert);
    }
}
